import { makeStyles } from 'tss-react/mui';

export default makeStyles<void, 'high' | 'low'>({ name: 'Ai' })((_, __, classes) => ({
    confidence: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        fontSize: 14,
        fontWeight: 600,
        lineHeight: '24px',
        textTransform: 'capitalize',
        ['& > svg']: {
            width: 16,
            height: 16
        },
        [`&.${classes.high}`]: {
            color: '#4CAF52'
        },
        [`&.${classes.low}`]: {
            color: '#FF3306'
        }
    },
    high: {},
    low: {}
}));
